import axios from 'axios';
import { LOGIN } from '../Types';

/**
 * Login
 *
 * @param {*} email
 * @param {*} password
 * @param {*} timeBasedToken
 */
export const login = (email, password, timeBasedToken) => {
  const credentials = { email, password };
  if (timeBasedToken) {
    credentials.timeBasedToken = timeBasedToken;
  }
  return (dispatch) => {
    const action = {
      type: LOGIN,
      request: async () => {
        const user = await axios
          .post('/login', credentials)
          .then((res) => res.data);
        return user;
      },
    };

    dispatch(action);
  };
};

export default login;
